// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-ui-Badge-styles__root","large":"src-components-ui-Badge-styles__large"};